import { render, staticRenderFns } from "./MatchLetterVoiceStep.vue?vue&type=template&id=f529acd6"
import script from "./MatchLetterVoiceStep.vue?vue&type=script&lang=js"
export * from "./MatchLetterVoiceStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports